import { GetSummaryAllScopesResponse } from "@mobiletract/esg-calculator-service-angular-client";
import { createAction, props } from "@ngrx/store";

export const loadSummary = createAction('[Summary] Load Summary', props<{ companyId: string, companyUnitIds: string[], year: number }>());
export const loadSummarySuccess = createAction('[Summary] Load Summary Success', props<{ summary: GetSummaryAllScopesResponse }>());
export const loadSummaryFailure = createAction('[Summary] Load Summary Failure', props<{ error: any }>());
